<style lang="scss">
// Timeslot
.agenda-daily-event {
  cursor: pointer;
  transition: all 0.2s;
  width: 100%;
  height: 100%;
  font-size: 12px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: var(--theme-shadow) !important;
  }
}

.agenda-daily-event__filled {
  background-color: var(--theme-grey-bg);

  .customer-enter {
    font-size: 10px;
    padding: 3px 5px;
    border-radius: 5px;
    color: black;
    background: white;
    border: 1px black solid;
    transition: .3s;

    &:hover {
      background: black;
      color: white;
    }
  }

  .timeslot-wrapper {

    // Photo Column
    .photo-col {
      flex: 0 0 30px;
      padding: 5px;

      .customer-photo {
        width: 30px;
        height: 30px;
        border-radius: 15px;
        object-fit: cover;
      }
    }

    .col.content-col {
      padding: 5px;

      h6 {
        font-size: 13px;
        font-weight: bold;
        color: var(--theme-text-color);
      }

      p {
        font-size: 12px;
        line-height: 12.7px;
        color: var(--theme-text-color);
      }
    }

    .icons-col {
      overflow: hidden;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: flex-start;

      &>* {
        margin: 2px;
      }

      .icon-gone {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 24px;
        height: 24px;
        border-radius: 12px;
        border: 1px var(--theme-text-color) solid;
        background-color: white;

        i {
          font-size: 10px;
          color: var(--theme-text-color);
        }
      }
    }
  }

  &.arrived {
    background-color: var(--theme-color-arrived);
    color: white;

    .col.content-col {

      h6,
      p {
        color: white;
      }
    }
  }

  &.attended {
    background-color: var(--theme-color-attended);
    color: white;

    .col.content-col {

      h6,
      p {
        color: white;
      }
    }
  }

  &.cancel {
    background-color: var(--theme-color-canceled);
    color: white;

    .col.content-col {

      h6,
      p {
        color: white;
      }
    }
  }

  &.absent {
    background-color: var(--theme-color-absent);
    color: white;

    .col.content-col {

      h6,
      p {
        color: white;
      }
    }
  }

  &.treated {
    background-color: var(--theme-color-treated);
    color: white;

    .col.content-col {

      h6,
      p {
        color: white;
      }
    }
  }

  &.gone {
    background-color: var(--theme-color-gone);

    .timeslot-wrapper {
      opacity: 0.5;
    }
  }

  &.revision {
    background-color: var(--theme-color-revision);
    color: white;

    .col.content-col {

      h6,
      p {
        color: white;
      }
    }
  }

  &.urgent {
    background-color: var(--theme-color-urgent);
    color: white;

    .col.content-col {

      h6,
      p {
        color: white;
      }
    }
  }

  &.insurance {
    background-color: var(--theme-color-insurance);
    color: white;

    .col.content-col {

      h6,
      p {
        color: white;
      }
    }
  }

  &.marked {
    background-color: var(--theme-color-marked);
    color: white;

    .col.content-col {

      h6,
      p {
        color: white;
      }
    }
  }
}
</style>

<template>
  <div @click="cellClick" :style="cell_style" class="agenda-daily-event agenda-daily-event__filled" :class="cell_class">
    <div class="timeslot-wrapper text-left">
      <div v-if="has_photo" class="col photo-col">
        <img loading="lazy" :style="{ transform: `rotate(${appointment.customer.photo_rotate}deg)` }"
          class="customer-photo" :src="`/customer/${appointment.customer.id}/thumbnail`" />
      </div>
      <div class="content-col">
        <h6 v-if="appointment.customer">
          {{ appointment.customer.full_name }}
          &nbsp;
          <i v-if="customer_can_enter" @click.stop="customerEnters" class="customer-enter fa fa-sign-in-alt"
            aria-hidden="true"></i>
        </h6>
        <h6 v-else>NOTA:</h6>
        <p class="mb-1" v-if="show_phone">{{ appointment.customer.phone }}</p>
        <p class="mb-1" v-if="doctor">{{ doctor.name }}</p>
        <p class="mb-4">{{ notes }}</p>
      </div>
      <div class="icons-col">
        <img v-if="appointment.status == 'attended'" src="/images/atendido.svg" />

        <div class="icon-gone" v-if="appointment.status == 'pending' && is_core" data-trigger="tooltip"
          title="Pendiente">
          <i class="fa fa-clock-o"></i>
        </div>

        <div class="icon-gone" v-if="appointment.status == 'confirmed' && is_core" data-trigger="tooltip"
          title="Confirmada">
          <i class="fas fa-thumbs-up"></i>
        </div>

        <div class="icon-gone" v-if="appointment.status == 'arrived' && is_core" data-trigger="tooltip" title="Llegó">
          <i class="fas fa-users"></i>
        </div>

        <div class="icon-gone" v-if="appointment.status == 'treated' && is_core" data-trigger="tooltip"
          title="Saliendo">
          <i class="fas fa-door-closed"></i>
        </div>

        <div class="icon-gone" v-if="appointment.status == 'gone'" data-trigger="tooltip" title="Se fue">
          <i class="fas fa-door-open"></i>
        </div>

        <div class="icon-gone" v-if="appointment.status == 'cancel'" data-trigger="tooltip" title="Cancelada">
          <i class="fas fa-times"></i>
        </div>

        <div class="icon-gone" v-if="appointment.status == 'absent'" data-trigger="tooltip" title="No acude/No avisa">
          <i class="fas fa-times"></i>
        </div>

        <div class="icon-gone" v-if="appointment.customer && !appointment.customer.has_paid" data-toggle="tooltip"
          data-trigger="hover" title="Pagos pendientes">
          <i class="fas fa-money-bill-alt"></i>
        </div>

        <div class="icon-gone" v-if="appointment.customer && !appointment.customer.is_consent_signed"
          data-toggle="tooltip" data-trigger="hover" title="Debe firmar consentimiento">
          <i class="fas fa-edit"></i>
        </div>

        <template v-for="(section, i) in customer_history">
          <template v-for="(item, j) in section">
            <img v-if="history_icons[j] && section[j]" :key="i + '_' + j" alt="j" :src="history_icons[j]"
              data-toggle="tooltip" data-trigger="hover" :title="j" />
          </template>
        </template>

        <div class="icon-gone" v-if="show_notes" :id="'customer_notes_' + appointment.id" type="button">
          <i class="fas fa-exclamation-triangle"></i>
        </div>

        <b-popover v-if="show_notes" :target="'customer_notes_' + appointment.id" triggers="hover" placement="righttop">
          <template #title>{{ appointment.customer.full_name }}</template>
          {{ appointment.customer.notes }}
          <hr>
          <div v-for="(section, name) in filtered_customer_history" :key="name">
            <small><strong>{{ name }}: </strong></small>
            {{ section }}
          </div>
        </b-popover>

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: ["appointment", "box", "doctors"],
  data() {
    return {
      history_icons: {
        penicillin: "/images/penicilina.svg",
        latex: "/images/latex.svg",
        hiv: "/images/vih.svg",
        hepatitis: "/images/hepatitis.svg",
        heart_condition: "/images/cardiacos.svg",
        diabetes: "/images/diabetes.svg",
      },
    };
  },
  computed: {
    show_phone() {
      return (
        this.appointment &&
        this.appointment.customer &&
        this.clinic &&
        this.clinic.config.enable_coreclinic
      );
    },
    show_notes() {
      return this.appointment.customer && this.appointment.customer.notes;
    },
    customer_can_enter() {
      if (!this.appointment.customer) return false;

      return this.appointment.status == 'pending' || this.appointment.status == 'confirmed';
    },
    is_note() {
      return this.appointment.customer_id != null;
    },
    doctor() {
      if (!this.doctors || !this.appointment) return null;
      return this.doctors[this.appointment.doctor_id] || null;
    },
    filtered_customer_history() {
      const section_translations = {
        allergies: 'Alergias',
        diseases: 'Enfermedades',
        background: 'Antecedentes',
        habits: 'Habitos',
      };

      let ret = {};

      for (const section_name in this.customer_history) {
        let n = section_translations[section_name] || null;
        if (n) {
          ret[n] = this.filterCustomerHistory(this.customer_history[section_name]);
        }
      }

      return ret;
    },
    customer_history() {
      if (!this.appointment.customer) return [];
      return this.appointment.customer.history;
    },
    has_photo() {
      return !(
        this.appointment.customer == null ||
        this.appointment.customer.photo == null ||
        this.appointment.customer.photo == ""
      );
    },
    app_color() {
      if (!this.appointment) {
        return null;
      }

      if (this.appointment.color && this.appointment.color !== "null" &&
        this.appointment.color !== "#000000"
      ) {
        return this.appointment.color;
      }

      if (this.appointment.treatments.length > 0) {
        let tcolor = this.appointment.treatments[0].product.color;
        if (tcolor && tcolor !== "null" &&
          tcolor !== "#000000"
        ) {
          return tcolor;
        }
      }

      let dcolor = this.doc_color;
      if (dcolor) {
        return dcolor;
      }

      return null;
    },
    notes() {
      let ret = [];

      if (this.appointment) {
        if (this.appointment.is_first) {
          ret.push('1ª Cita');
        };

        this.appointment.treatments.forEach((t) => {
          let postfix = '';
          if (t.limit_sessions) {
            postfix = `(${t.sessions_done}/${t.max_sessions})`;
          }

          ret.push(t.product.name + postfix);
        });

        if (this.appointment.notes && this.appointment.notes != '') {
          ret.push(this.appointment.notes);
        }
      }

      return ret.join(' - ');
    },
    doc_color() {
      if (!this.doctor) {
        return null;
      }

      if (
        !this.doctor.color ||
        this.doctor.color == "null" ||
        this.doctor.color == "#000000"
      ) {
        return null;
      }

      return this.doctor.color;
    },
    cell_style() {
      let ret = {
      };

      if (this.isWaiting() || (this.clinic && this.clinic.config.enable_coreclinic)) {
        ret["background-color"] = this.app_color;
      }

      return ret;
    },
    cell_class() {
      let ret = {};
      if (this.isFilled()) {
        let classname = null;

        if (this.appointment.is_marked) {
          classname = "marked";
        } else if (this.appointment.is_urgent) {
          classname = "urgent";
        } else if (this.appointment.is_revision) {
          classname = "revision";
        } else if (this.appointment.is_insurance) {
          classname = "insurance";
        }

        if (this.appointment.status != "pending") {
          classname = this.appointment.status;
        }

        if (classname) {
          ret[classname] = true;
        }
      }

      return ret;
    },
    ...mapGetters(["clinic", "is_core"]),
  },
  methods: {
    filterCustomerHistory(section) {
      let ret = [];
      const translationTable = {
        penicillin: 'Penicilina',
        latex: 'Látex',
        hepatitis: 'Hepatitis',
        diabetes: 'Diabetes',
        hiv: 'HIV',
        heart_condition: 'Enf. Card.',
        headache: 'Cefalea',
        neuralgia: 'Neuralgia',
        bruxism: 'Bruxismo',
        tobacco: 'Tabaco',
        alcohol: 'Alcohol',
        drugs: 'Drogas',
      };


      for (const key in section) {
        const translation = translationTable[key];
        const value = section[key];

        if (!value) continue;

        if (translation) {
          ret.push(translation);
          continue;
        }

        if (Array.isArray(value)) {
          ret.push(value.join(','));
          continue;
        };

        if (value && value.constructor === Object) {
          for (const subkey in value) {
            const subvalue = value[subkey];
            const subtrans = translationTable[subkey];
            if (!subvalue) continue;
            if (subtrans) {
              ret.push(subtrans);
            }
          }
        };
      }

      return ret.join(', ');
    },
    customerEnters(ev) {
      this.$emit("customerEnters", this.appointment, null, this.box);
    },
    isFilled() {
      return this.appointment != null;
    },
    isWaiting() {
      return this.appointment != null && this.appointment.status == "pending";
    },
    cellClick() {
      this.$emit("cellClick", this.appointment, null, this.box);
    },
  },
  mounted() {
  },
};
</script>
